export default "__VITE_ASSET__BVMnUXxy__"